import React from "react";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";

const TextSection = ({ title, description }) => {
  return (
    <section className={s.terms_container}>
      <div className={s.body_container}>
        <div className={s.title_heading}>
          <PrismicRichText field={title || []} />
        </div>
        <div className={`${s.sub_title} secondaryFont`}>
          <PrismicRichText field={description || []} />
        </div>
      </div>
    </section>
  );
};

export default TextSection;
